<template>
  <v-app :dark="true">
    <router-view v-if="isRouterAlive"></router-view>
    <!-- global snackbar -->
    <v-snackbar :timeout="snackbar.timeout" top center :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn class="right-btn" dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="signTipData.snackBar"
      :max-width="signTipData.maxWidth"
      :timeout="signTipData.timeout"
      :right=true
      :top=true
      :content-class="contentClass"
    >
      {{ signTipData.displayContent }}
      <template v-slot:action="{ attrs }" v-if="signTipData.displayCheckBtn">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="reload"
        >
          Check it
        </v-btn>
      </template>
    </v-snackbar>

  </v-app>
</template>
<script>
import { AppEvents } from '@/util/event'
import colors from 'vuetify/es5/util/colors'
import { DataType, Tool } from '@/util/index'
import { _ } from 'vue-underscore'
import { DictionaryApi } from '@/api/pandaria'

const tool = new Tool()

export default {
  components: {},
  data () {
    return {
      rightDrawer: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
        timeout: 3000
      },
      colors: colors,
      isRouterAlive: true,
      signTipData: {
        snackBar: false,
        timeout: 10000,
        maxWidth: 450,
        displayCheckBtn: false,
        displayContent: '',
        disableVAContent: 'Loan agreement of <%= data.loanNo %> has just been signed by customer.',
        enableVAContent: 'Loan agreement of <%= data.loanNo %> has just been signed by customer. And <%= data.loanNo %> has been sent to Application Reviewer'
      },
      contentClass: 'width-400'
    }
  },
  destroyed () {
    this.$eventBus.$off('popSignedTips')
  },
  mounted () {
    if (typeof window !== 'undefined' && window._VMA === undefined) {
      window._VMA = this
    }
    this.$eventBus.$on('popSignedTips', target => {
      const loanStatus = target.loanStatus
      const portfolioId = target.portfolioId
      const runtimePortfolio = this.store.getters.getRuntimePortfolio
      if (runtimePortfolio.includes(portfolioId)) {
        if (loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          this.signTipData.displayContent = _.template(this.signTipData.enableVAContent)({ data: target })
        } else {
          this.signTipData.displayContent = _.template(this.signTipData.disableVAContent)({ data: target })
        }
      }
      this.signTipData.snackBar = true
    })

    this.initDictionary()
  },
  created () {
    this.$on('SHOW_SNACKBAR', (e) => {
      this.snackbar = {
        show: true,
        text: e.text,
        color: e.color,
        timeout: e.timeout ? e.timeout : 3000
      }
    })
    // add app events
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback)
    })
    window.getApp = this
    this.$vuetify.theme.primary = this.colors.lightBlue.base
  },
  methods: {
    reload () {
      this.signTipData = this.$options.data().signTipData
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    initDictionary () {
      this.initAuditRelatedEnum()
    },
    async initAuditRelatedEnum () {
      let correctionReasonList = []
      let correctionReasonCategoryList = []
      let auditDetailsStatusList = []

      const auditSectionKeyEnum = []
      const auditReasonEnum = []
      const auditDetailsStatusEnum = {}

      await DictionaryApi.listDomainByCode('CORRECTION_REASON', function (result) {
        correctionReasonList = result
      })
      await DictionaryApi.listDomainByCode('CORRECTION_REASON_CATEGORY', function (result) {
        correctionReasonCategoryList = result
      })
      await DictionaryApi.listDomainByCode('AUDIT_DETAILS_STATUS', function (result) {
        auditDetailsStatusList = result
      })

      const correctionReasonEnum = []
      const groupParent = {}
      for (const correctionReason of correctionReasonList) {
        const extension = correctionReason.extension
        if (tool.isNotEmpty(extension)) {
          correctionReason.parent = tool.arrayToObject(extension).parent
        }
        if (tool.isEmpty(groupParent[correctionReason.parent])) {
          groupParent[correctionReason.parent] = []
        }
        groupParent[correctionReason.parent].push(correctionReason)
        auditReasonEnum.push({
          value: parseInt(correctionReason.value, 10),
          text: correctionReason.text
        })
      }

      for (const correctionReasonCategory of correctionReasonCategoryList) {
        const extension = correctionReasonCategory.extension
        if (tool.isNotEmpty(extension)) {
          correctionReasonCategory.loanStatus = tool.arrayToObject(extension).loanStatus
        }
        correctionReasonCategory.items = groupParent[correctionReasonCategory.value]
        correctionReasonEnum.push(correctionReasonCategory)
        auditSectionKeyEnum.push({
          value: correctionReasonCategory.value,
          text: correctionReasonCategory.text
        })
      }

      for (const auditDetailsStatus of auditDetailsStatusList) {
        auditDetailsStatusEnum[auditDetailsStatus.code] = {
          value: parseInt(auditDetailsStatus.value, 10),
          text: auditDetailsStatus.text
        }
      }

      this.store.commit('setCorrectionReasonEnum', correctionReasonEnum)
      this.store.commit('setAuditSectionKeyEnum', correctionReasonCategoryList)
      this.store.commit('setAuditReasonEnum', correctionReasonList)
      this.store.commit('setAuditDetailsStatusEnum', auditDetailsStatusEnum)
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  }
}
</script>

<style lang="sass" scoped>
.setting-fab
  top: 50% !important
  right: 0
  border-radius: 0
.right-btn
  position: absolute
  right: 5px
  top: 5px
</style>
<style lang="scss">
@import '../src/assets/fonts/font-montserrat/font.css';
</style>
